import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldAlert, Loader2 } from "lucide-react";

const ROUTE = { privacy: "/privacy", cookie: "/cookie-policy", terms: "/terms", dpa: "/dpa" };

export default function LegalGate() {
  const { user, lang } = useApp();
  const L = (it, en) => (lang === "en" ? en : it);
  const [pending, setPending] = useState([]);
  const [checked, setChecked] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) { setPending([]); return; }
    api.get("/legal/consent/pending").then((r) => setPending(r.data.pending || [])).catch(() => {});
  }, [user]);

  if (!user || pending.length === 0) return null;
  const allChecked = pending.every((p) => checked[p.type]);

  const accept = async () => {
    setBusy(true);
    try { await api.post("/legal/consent/accept", { types: pending.map((p) => p.type) }); setPending([]); toast.success(L("Grazie, aggiornamento accettato", "Thanks, update accepted")); }
    catch { toast.error("Error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" data-testid="legal-gate">
      <div className="bg-background rounded-2xl border border-border max-w-md w-full p-6">
        <ShieldAlert className="w-10 h-10 text-primary mb-3" />
        <h2 className="text-xl font-bold mb-2">{L("Aggiornamento dei documenti legali", "Legal documents updated")}</h2>
        <p className="text-sm text-muted-foreground mb-4">{L("Abbiamo aggiornato alcuni documenti. Per continuare devi prendere visione e accettare le nuove versioni.", "We updated some documents. To continue, please review and accept the new versions.")}</p>
        <div className="space-y-2 mb-5">
          {pending.map((p) => (
            <label key={p.type} className="flex items-center gap-2 text-sm" data-testid={`gate-check-${p.type}`}>
              <input type="checkbox" checked={!!checked[p.type]} onChange={(e) => setChecked({ ...checked, [p.type]: e.target.checked })} />
              <span>{L("Accetto", "I accept")} <Link to={ROUTE[p.type] || "/"} target="_blank" className="text-primary hover:underline">{p.title}</Link> (v{p.version})</span>
            </label>
          ))}
        </div>
        <Button className="w-full" disabled={!allChecked || busy} onClick={accept} data-testid="gate-accept">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : L("Accetta e continua", "Accept & continue")}
        </Button>
      </div>
    </div>
  );
}
